module.exports = __webpack_public_path__ + "img/sweden-respiratory-diseases-male.b960b185.png";